import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { Box, ListItemButton, ListItemText, Typography } from '@mui/material';

import { QuickFiltersList } from '../../common/interfaces/quickFilters/QuickFilters';
import { taskViewActions } from './slices/statusSlice';

export const MenuItem = ({
  sectionIndex,
  filterIndex,
  selectedFilterIndex,
  selectedSectionIndex,
  taskCounts,
  quickFilter,
}: {
  sectionIndex: number;
  filterIndex: number;
  selectedFilterIndex: number;
  selectedSectionIndex: number;
  taskCounts: any;
  quickFilter: QuickFiltersList;
}) => {
  const dispatch = useDispatch();
  const count = useMemo(() => {
    const queryBody = quickFilter?.queryBody;

    if (
      taskCounts &&
      queryBody?.taskState?.length === 1 &&
      queryBody?.taskType?.length! > 0
    ) {
      const tasksByType = taskCounts[queryBody?.taskState[0]];
      if (tasksByType) {
        const taskCount =
          tasksByType[
            queryBody?.taskType?.length === 1 ? queryBody?.taskType[0] : 'ALL'
          ];
        if (Number.isFinite(taskCount)) {
          return taskCount;
        }
      }
    }

    return null;
  }, [taskCounts, quickFilter]);

  const isSelected = (): boolean =>
    sectionIndex === selectedSectionIndex &&
    filterIndex === selectedFilterIndex;

  return (
    <ListItemButton
      selected={isSelected()}
      disabled={count === 0}
      onClick={() => {
        dispatch(
          taskViewActions.onTaskViewChange({
            lastSectionIndex: sectionIndex,
            lastFilterIndex: filterIndex,
          }),
        );
      }}
    >
      <ListItemText
        primary={quickFilter.display}
        sx={{
          '.MuiListItemText-primary': {
            fontSize: '14.75px',
          },
        }}
      />
      <Box mr={2}>
        {Number.isFinite(count) && count > 0 && (
          <Typography variant="subtitle2">{count}</Typography>
        )}
      </Box>
    </ListItemButton>
  );
};
